(()=>{
 const root=document.querySelector('#shopify-section-knr-049');
 if(!root||!document.documentElement.classList.contains('ks-rings-hero-preview'))return;
 const heading=root.querySelector('.ks-pdp-heading h1');
 const highlight='One Set of Rings.';
 if(heading&&!heading.querySelector('.dr-headline-accent')){
  const copy=heading.textContent;
  const start=copy.indexOf(highlight);
  if(start!==-1){
   const accent=document.createElement('span');
   accent.className='dr-headline-accent';accent.textContent=highlight;
   heading.replaceChildren(document.createTextNode(copy.slice(0,start)),accent,document.createTextNode(copy.slice(start+highlight.length)));
  }
 }
 const icons=[
  '<path d="M19 9a7.5 7.5 0 1 0 0 6M19 4v5h-5"/><circle cx="11" cy="12" r="3"/>',
  '<circle cx="12" cy="12" r="6"/><path d="M12 1v5m-3-2 3 3 3-3M12 23v-5m-3 2 3-3 3 3"/>',
  '<rect x="7" y="2" width="10" height="20" rx="2"/><path d="M7 7h5m-5 5h7m-7 5h5"/>'
 ];
 root.querySelectorAll('.ks-pdp-benefits li').forEach((li,i)=>{
  const current=li.querySelector('svg');if(!current||!icons[i])return;
  const holder=document.createElement('template');
  holder.innerHTML='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+icons[i]+'</svg>';
  current.replaceWith(holder.content.firstElementChild);
 });
 root.querySelectorAll('a.ks-assurance-item').forEach(link=>{
  const item=document.createElement('div');item.className=link.className;
  while(link.firstChild)item.appendChild(link.firstChild);
  link.replaceWith(item);
 });
})();
